type OperatingHoursSource = {
  operating_hours?: string | null;
  weekday_operating_hours?: string | null;
  weekend_holiday_operating_hours?: string | null;
};

type OperatingHoursState = {
  weekdayOperatingHours: string;
  weekendHolidayOperatingHours: string;
};

const normalizeText = (value?: string | null) => {
  const normalized = value?.trim() ?? "";
  return normalized.length > 0 ? normalized : "";
};

export const normalizeOperatingHoursFields = (
  source: OperatingHoursSource,
): OperatingHoursState => {
  const legacyOperatingHours = normalizeText(source.operating_hours);
  return {
    weekdayOperatingHours:
      normalizeText(source.weekday_operating_hours) || legacyOperatingHours,
    weekendHolidayOperatingHours:
      normalizeText(source.weekend_holiday_operating_hours) || legacyOperatingHours,
  };
};

export const buildOperatingHoursInfoPayload = ({
  weekdayOperatingHours,
  weekendHolidayOperatingHours,
}: OperatingHoursState) => {
  const weekday = normalizeText(weekdayOperatingHours);
  const weekendHoliday = normalizeText(weekendHolidayOperatingHours);
  const operatingHoursParts = [
    weekday ? `주중 ${weekday}` : null,
    weekendHoliday ? `주말·공휴일 ${weekendHoliday}` : null,
  ].filter(Boolean);

  return {
    weekday_operating_hours: weekday || null,
    weekend_holiday_operating_hours: weekendHoliday || null,
    operating_hours: operatingHoursParts.length > 0 ? operatingHoursParts.join(" / ") : null,
  };
};
